import React from 'react';
import { store } from '../../store'
import TilbodNavigation from '../tilbod-navigation'
import Tab from 'react-bootstrap/Tab'
import TabContainer from 'react-bootstrap/TabContainer'
import TabContent from 'react-bootstrap/TabContent'
import Nav from 'react-bootstrap/Nav'
import { customerNameById, formatKennitala, allConfirmsChecked, getDescriptiveContractName, allCustomersConfirmed, getContractNameDetail } from '../../utils'

import connectWithStore from '../../utils/store'

import { setInfoKey, setInfoKeyMulti } from '../../api/information-collection/actions'

import BaseForm from '../base-form'

import Accordion from 'react-bootstrap/Accordion'
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import Card from 'react-bootstrap/Card'
import Button from 'react-bootstrap/Button'

import { SvgArrowIcon, SvgCheckIcon } from '../svg';
import { setStale } from '../../api/offers/actions'


import Form from '../form'
import { nationalRegistry } from '../../api/national-registry/reducers';

class TilbodStepCollectInfo extends React.Component {

    constructor(props) {
        super(props)
        this.state = { activeKey: 0 }

        this.onButtonClick = this.onButtonClick.bind(this)
        this.onSuccess = this.onSuccess.bind(this)
    }

    getInitialValues(customerId) {
        return this.props.infoCollection.data[customerId]
    }

    UNSAFE_componentWillMount() {
        Object.keys(this.props.offers.offerQueryParameters).map((customerId, idx) => {
            this.props.dispatch(setInfoKey({ key: undefined, value: undefined }, customerId))
        })
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.dispatch(setStale(true))
    }

    onNavLinkClick(customerId, e) {
        var tab = $(e.target).parents('.nav-item').prev('.nav-item');

        $('.tabs .nav-item').removeClass('no-border');
        tab.addClass('no-border');

        this.setState({ activeKey: `${customerId}-0` })
    }

    onButtonClick(key, e) {
        this.setState({ activeKey: key })
        
        $(e.target).parent().siblings('.collapse').toggleClass('show')

    }

    onConfirmRenderCheck(productCode, customerId) {
        let customer = this.props.infoCollection.data[customerId]
        if (customer[`${productCode.toLowerCase()}Confirm`] === false) {
            return false
        }

        return true

    }

    isAdult(customers, customerId) {
        let cust = customers.customerList.filter(c => c.Customer.AccountNum === customerId)
        let adult = false;

        if (cust[0].type === "adult") {
            adult = true
        }

        return adult
    }

    onSuccess(customerId, idx) {
        this.setState({activeKey: `${customerId}-${idx+1}`})
    }

    infoCollectionComplete(customerId){
        return this.props.infoCollection.data[customerId].confirm
    }

    render() {
        let customers = this.props.customers;
        return (
            <>
                <div className="row justify-content-center xs-pt-10">
                    <div className="col-12 col-sm-10 col-md-8">
                        <div className="row justify-content-center xs-pt-10 step">
                            <Tab.Container id="base-info-collection-tabs" defaultActiveKey={Object.keys(this.props.offers.offerQueryParameters)[0]} >
                                <div className="tabs-container">
                                    <Nav variant="tabs" className="tabs">
                                        {Object.keys(this.props.offers.offerQueryParameters).map((customerId, idx) =>
                                            <Nav.Item key={customerId} className="check">
                                                <Nav.Link eventKey={customerId} onClick={this.onNavLinkClick.bind(this, customerId)}>
                                                    {customerNameById(customerId, this.props.customers)}<span>({formatKennitala(customerId)})</span>
                                                </Nav.Link>
                                                { allConfirmsChecked(customerId, this.props.infoCollection, this.props.offers) &&
                                                    <span className="check-icon small blue"><SvgCheckIcon /></span>
                                                }
                                            </Nav.Item>
                                        )}
                                    </Nav>
                                </div>
                                <Tab.Content className="w-100">
                                    {Object.keys(this.props.offers.offerQueryParameters).map((customerId, idx) =>
                                        <Tab.Pane key={customerId} eventKey={customerId}>
                                            <Accordion defaultActiveKey={`${customerId}-${0}`} activeKey={this.state.activeKey}>
                                                <Card className={this.props.infoCollection.data[customerId].confirm && "checked"}>
                                                    <Card.Header>
                                                        <Accordion.Toggle as={Button} variant="link" eventKey={`${customerId}-${0}`} onClick={(e) => this.onButtonClick(`${customerId}-${0}`, e)} className="toggle-button">
                                                            {this.infoCollectionComplete(customerId) ? (<span className="check"><span className="check check-icon big green">
                                                                <SvgCheckIcon />
                                                            </span></span>) : (<span></span>)}
                                                            Grunnupplýsingar
                                                            <span className="arrow-toggle-button">
                                                                <SvgArrowIcon />
                                                            </span>
                                                        </Accordion.Toggle>
                                                    </Card.Header>
                                                    <Accordion.Collapse className={this.state.activeKey === 0 ? 'show' : ''} eventKey={`${customerId}-${0}`}>
                                                        <Card.Body>
                                                            <BaseForm onSuccess={() => this.onSuccess(customerId, 0)} nationalRegistry={this.props.nationalRegistry} customerId={customerId} customers={this.props.customers} dispatch={this.props.dispatch} jobs={this.props.jobs} initialValues={this.getInitialValues(customerId)} offers={this.props.offers} infoCollection={this.props.infoCollection} />
                                                        </Card.Body>
                                                    </Accordion.Collapse>
                                                </Card>
                                                {Object.keys(this.props.offers.offerQueryParameters[customerId]).map((productCode, idx) =>

                                                    <React.Fragment key={`${customerId}-${productCode}`}>
                                                        {this.props.offers.offerQueryParameters[customerId][productCode] === true &&
                                                            <Card className={this.onConfirmRenderCheck(productCode, customerId) && "checked"}>
                                                                <Card.Header>
                                                                    <Accordion.Toggle as={Button} variant="link" eventKey={`${customerId}-${(idx+1)}`} onClick={(e) => this.onButtonClick(`${customerId}-${(idx+1)}`, e)} className="toggle-button">
                                                                        {this.onConfirmRenderCheck(productCode, customerId) &&
                                                                            <span className="check">
                                                                                <span className="check check-icon big green">
                                                                                    <SvgCheckIcon />
                                                                                </span>
                                                                            </span>
                                                                        }
                                                                        {getDescriptiveContractName(productCode)}
                                                                        {getContractNameDetail(this.props.infoCollection, customerId, productCode)}

                                                                        <span className="arrow-toggle-button">
                                                                            <SvgArrowIcon />
                                                                        </span>
                                                                    </Accordion.Toggle>
                                                                </Card.Header>
                                                                <Accordion.Collapse eventKey={`${customerId}-${(idx+1)}`}>
                                                                    <Card.Body>
                                                                        <Form 
                                                                            onSuccess={() => this.onSuccess(customerId, idx+1)}
                                                                            formType={productCode}
                                                                            dispatch={this.props.dispatch}
                                                                            customerId={customerId}
                                                                            nationalRegistry={this.props.nationalRegistry}
                                                                            initialValues={this.getInitialValues(customerId)}
                                                                            insuranceTakers={this.props.insuranceTakers}
                                                                            infoCollection={this.props.infoCollection.data[customerId]}
                                                                            currency={this.props.currency}
                                                                            customers={this.props.customers}
                                                                            gui={this.props.gui}
                                                                            isAdult={this.isAdult(customers, customerId)}
                                                                            fundTable={this.props.fundTable} />
                                                                    </Card.Body>
                                                                </Accordion.Collapse>
                                                            </Card>
                                                        }
                                                    </React.Fragment>
                                                )}
                                            </Accordion>
                                        </Tab.Pane>
                                    )}
                                </Tab.Content>
                            </Tab.Container>
                        </div>
                    </div>
                </div>

                <TilbodNavigation />
            </>
        )
    }
}

TilbodStepCollectInfo.defaultProps = {
}

function mapStateToProps(state) {

    var f = {
        customers: {},
        offers: {},
        gui: {},
        nationalRegistry: {},
        infoCollection: {},
        currency: {},
        jobs: {},
        fundTable: {},
        insuranceTakers: {},
    }
    f.customers = (state.customers === undefined) ? {} : state.customers
    f.offers = (state.offers === undefined) ? {} : state.offers
    f.gui = (state.gui === undefined) ? {} : state.gui
    f.nationalRegistry = (state.nationalRegistry === undefined) ? {} : state.nationalRegistry
    f.infoCollection = (state.infoCollection === undefined) ? {} : state.infoCollection
    f.currency = (state.currency === undefined) ? {} : state.currency
    f.jobs = (state.jobs === undefined) ? {} : state.jobs
    f.fundTable = (state.fundTable === undefined) ? {} : state.fundTable
    f.insuranceTakers = (state.insuranceTakers === undefined) ? {} : state.insuranceTakers

    return f;
}

export default connectWithStore(store, TilbodStepCollectInfo, mapStateToProps);
